import initialReaderState from "../reader.initialState";
import { reduxActions as READER } from "_constants/reader.constants";
import { FAILURE, LOADING, SUCCESS } from "_constants/redux.constants";

const upload = {
  [READER.UPLOAD_ONE_STARTED]: (state) => ({
    ...state,
    one: {
      ...state.one,
      status: LOADING
    }
  }),

  [READER.UPLOAD_ONE_FAIL]: (state, { payload }) => ({
    ...state,
    one: {
      ...state.one,
      data : payload.data[0],
      status: FAILURE
    }
  }),

  [READER.UPLOAD_ONE_SUCCESS]: (state, { payload }) => ({
    ...state,
    one: {
      ...state.one,
      data: payload.data[0],
      status: SUCCESS
    }
  }),

  [READER.UPLOAD_ONE_RESET]: (state) => ({
    ...state,
    one: initialReaderState.one
  })
};

export default upload;
